import { useMemo } from 'react';

import { useSubscriptions } from '@adsk/alloy-provider';

import { SUBSCRIPTION_STATUS, SUBSCRIPTION_TYPES } from '../helpers/const';
import { Subscription } from '../helpers/types';
import { isPaidSubscription, shouldShowExpiredMessage } from '../helpers/utils';

const useUserSubscriptions = () => {
  const { data: userSubscriptionsData, error: userSubscriptionsError } =
    useSubscriptions();

  const userTrialSubscriptions = useMemo(() => {
    if (userSubscriptionsError) return null;
    if (!userSubscriptionsData) return null;

    return userSubscriptionsData
      .filter(
        (subscription: Subscription) =>
          subscription.type === SUBSCRIPTION_TYPES.TRIAL &&
          !isPaidSubscription(subscription, userSubscriptionsData),
      )
      .sort(
        (a: Subscription, b: Subscription) =>
          a.offeringCategoryRanking - b.offeringCategoryRanking,
      );
  }, [userSubscriptionsData, userSubscriptionsError]);

  const showBanner = useMemo(() => {
    if (userSubscriptionsError) return null;
    if (!userTrialSubscriptions) return null;
    if (userTrialSubscriptions.length === 0) return null;

    const noActiveTrials = userTrialSubscriptions.every(
      (subscription: Subscription) =>
        subscription.status === SUBSCRIPTION_STATUS.EXPIRED,
    );

    if (noActiveTrials) {
      return shouldShowExpiredMessage(userTrialSubscriptions);
    }

    return true;
  }, [userSubscriptionsError, userTrialSubscriptions]);

  return {
    userTrialSubscriptions,
    userSubscriptionsError,
    showBanner,
  };
};

export default useUserSubscriptions;
